import React from 'react';
import { Button, Popover } from '@sm360/ui-library';
import { LocaleService } from '@sm360/widget-commons-core-services';
import 'trade-in-360/components/InstantEstimateWrapper/Components/ActionButton/ActionButton.scss';

const ActionButton = ({
    next = false,
    noPrefix = false,
    noArrow = false,
    noSubmit = false,
    selected = false,
    loading = false,
    disabled = false,
    checkedIcon = false,
    center = false,
    classesName = [],
    children,
    right = false,
    isMainCTA = false,
    displayTooltip = false,
    toolTipText = '',
    ...buttonProps
}) => {
    classesName.push(next ? 'btn-primary' : 'btn-secondary');
    const classes = classesName.join(' ');

    const leftPartClassname = `${next ? 'uk-button--text' : 'uk-button--arrow'} ${loading ? 'loading' : ''}`;
    const rightPartClassname = next ? 'uk-button--arrow' : 'uk-button--text';

    const prefix = LocaleService.t(`TRADE_IN.BUTTONS.${next ? 'NEXT' : 'PREVIOUS'}`);
    const prefixChildren = noPrefix ? children : `${prefix} ${children}`;

    const leftArrow = noArrow ? '' : '<';
    const rightArrow = noArrow ? '' : '>';

    const leftPartText = next ? prefixChildren : leftArrow;
    const rightPartText = next ? rightArrow : prefixChildren;

    const ctaText = (
        <>
            <span className={leftPartClassname}>
                {checkedIcon && <icon className="icon-radio-button-on" />}
                {!loading && leftPartText}
            </span>
            <span className={rightPartClassname}>{!loading && rightPartText}</span>
        </>
    );

    return (
        <section
            className={`clearfix vehicle-buttons${next ? '--submit' : '--previous'} ${selected ? 'pressed' : ''} ${
                center ? 'center' : ''
            } ${right ? 'right' : ''} ${isMainCTA ? 'main-cta' : ''}`}
            data-test="trade-in.vehicle-form.submit"
        >
            <Button
                type={next && !noSubmit ? 'submit' : 'button'}
                disabled={loading || disabled}
                className={classes}
                {...buttonProps}
            >
                {!displayTooltip && ctaText}
                {displayTooltip && (
                    <Popover displayOnHover trigger={ctaText}>
                        {toolTipText}
                    </Popover>
                )}
            </Button>
        </section>
    );
};

ActionButton.displayName = 'ActionButton';

export default ActionButton;
